module.exports = __webpack_public_path__ + "static/img/Slide-1.3ad3621.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Slide-1.webp
// module id = iZKo
// module chunks = 0